<template>

    <div class="heading_component-page"><span>バリデーションエラー</span></div>
    <div class="comment">
        <p>エラーの input に対して<code>._error</code>を付与するとバリデーションエラー表示になります。</p>
        <p>さらに追加で<code>._required</code>を付与すると必須項目を求める表示になります。</p>
    </div>

    <div class="item form_text">
        <input type="text" maxlength="250" class="_error" id="example-input" placeholder=" " value="hogehoge" required>
        <label for="example-input" class="m-label"><span>Example</span></label>
    </div>

    <div class="item form_text">
        <input type="text" maxlength="250" class="_error _required" id="example-input" placeholder=" " value="hogehoge" required>
        <label for="example-input" class="m-label"><span>Example</span></label>
    </div>

</template>

